module.exports = __webpack_public_path__ + "static/media/12.949b8c0c.jpg";